import styled from 'styled-components/macro'
import logo from 'assets/images/hjbc_logo.png'
import { device } from 'constants/media-query'
import { getFontFamily } from './theme'

const FlexRow = styled.div<{
  gap?: number
  justify?: string
  align?: string
  mb?: string
  width?: string
}>`
  display: flex;
  ${({ gap }) => gap && `gap: ${gap}px`};
  ${({ justify }) => justify && `justify-content: ${justify}`};
  ${({ align }) => align && `align-items: ${align}`};
  ${({ mb }) => mb && `margin-bottom: ${mb}`};
  ${({ width }) => width && `width: ${width}`};
`

const FlexColumn = styled.div<{
  gap?: number
  justify?: string
  align?: string
  width?: string
  mb?: string
}>`
  display: flex;
  flex-direction: column;
  ${({ gap }) => gap && `gap: ${gap}px`};
  ${({ justify }) => justify && `justify-content: ${justify}`};
  ${({ align }) => align && `align-items: ${align}`};
  ${({ width }) => width && `width: ${width}`};
  ${({ mb }) => mb && `margin-bottom: ${mb}`};
`

const Heading1 = styled.h1<{
  align?: string
  alignSelf?: string
  fontSize?: string
  weight?: number
  color?: string
  lineHeight?: string
}>`
  ${({ weight = 400 }) => `font-weight: ${weight}`};
  ${({ fontSize = '32px' }) => `font-size: ${fontSize}`};
  ${({ align }) => align && `text-align: ${align}`};
  ${({ alignSelf }) => alignSelf && `align-self: ${alignSelf}`};
  ${({ color }) => color && `color: ${color}`};
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}`};
  margin: 0;
`

const Heading2 = styled.h2<{
  align?: string
  fontSize?: string
  weight?: number
  lineHeight?: string
  color?: string
}>`
  ${({ weight = 400 }) => `font-weight: ${weight}`};
  ${({ fontSize = '28px' }) => `font-size: ${fontSize}`};
  ${({ align }) => align && `text-align: ${align}`};
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight}`};
  ${({ color }) => color && `color: ${color}`};
  margin: 0;
`

const Heading3 = styled.h3<{
  align?: string
  fontSize?: string
  weight?: number
}>`
  ${({ weight = 400 }) => `font-weight: ${weight}`};
  ${({ fontSize = '24px' }) => `font-size: ${fontSize}`};
  ${({ align }) => align && `text-align: ${align}`};
  margin: 0;
`

const Text = styled.p<{
  fontSize?: string
  color?: string
  mb?: string
  weight?: number
  fontFamily?: string
}>`
  ${({ fontSize = '18px' }) => `font-size: ${fontSize}`};
  ${({ color }) => color && `color: ${color}`};
  margin: 0;
  ${({ mb }) => mb && `margin-bottom: ${mb}`};
  ${({ weight }) => weight && `font-weight: ${weight}`};
  font-family: ${({ theme }) => getFontFamily(theme)};
  ${({ fontFamily }) => fontFamily && `font-family: ${fontFamily}`};
`

const TextRegular = styled(Text)`
  font-size: 16px;

  @media ${device.desktop} {
    font-size: 20px;
  }
`

const Span = styled.span<{
  fontSize?: string
  color?: string
  fontFamily?: string
}>`
  ${({ fontSize = '18px' }) => `font-size: ${fontSize}`};
  ${({ fontFamily }) => fontFamily && `font-family: ${fontFamily}`};
`

const Button = styled.button<{
  type?: 'button' | 'submit' | 'reset' | undefined
}>`
  font-family: inherit;
  width: 100%;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: -0.075em;
  background: ${({ type }) => (type === 'reset' ? 'none' : 'rgba(0, 0, 0, 1)')};
  color: ${({ theme, type }) =>
    type === 'reset' ? theme.colors.black : theme.colors.white};
  padding: 15px 0;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &.disabled {
    font-family: ${({ theme }) => getFontFamily(theme)};
    background: #e1e1e1;
    cursor: default;
  }
`

const GreenButton = styled(Button)`
  background-color: ${({ theme }) => theme.primaryGreen};
  padding: 10px 20px;
  color: ${({ theme }) => theme.white};
  font-size: 20px;
  min-width: 100px;
`

const BorderButton = styled(Button)`
  border: 1px solid ${({ theme }) => theme.hjRed};
  padding: 10px 20px;
  color: ${({ theme }) => theme.hjRed};
  font-size: 20px;
  min-width: 100px;
`

const Image = styled.img<{ width?: string }>`
  ${({ width }) => width && `width: ${width}`};
`

const Logo = styled(Image).attrs({
  src: logo,
  alt: 'Hapoel Jerusalem Logo',
})`
  width: 100px;
  height: 'auto';
`

const IconContainer = styled.div<{ width?: string }>`
  ${({ width }) => width && `width: ${width}`};
  display: flex;
  justify-content: center;
  align-items: center;
`

export {
  FlexRow,
  FlexColumn,
  Heading1,
  Heading2,
  Heading3,
  Text,
  TextRegular,
  Button,
  Image,
  Span,
  GreenButton,
  BorderButton,
  Logo,
  IconContainer,
}
